import { 
    WORK_BEGIN,
    WORK_ADD,
    WORK_FAILURE,
} from 'app/actions/WorkActions';

const initialState = {
	byId: {},
	allIds: [],
	isLoading: false,
};

export default function WorkReducer (state = initialState, action) {
	switch (action.type) {
        case WORK_BEGIN: 
			return {
				...state,
				isLoading: true
			}
        case WORK_ADD: 
			let allIds = [...new Set(state.allIds.concat(action.payload.data.allIds))];
			let byId = {
				...state.byId,
				...action.payload.data.byId
			};
			return {
				...state,
				allIds,
				byId,
				isLoading: false,
			};
        case WORK_FAILURE: 
			return {
				...state,
				isLoading: false
			}
		default:
			return state;
	}
};

export const getWork = state => {
	return state.allIds.map( id => state.byId[id] );
}